import { render, staticRenderFns } from "./mncs-distribution-team.vue?vue&type=template&id=f65f2c26"
import script from "./mncs-distribution-team.vue?vue&type=script&lang=js"
export * from "./mncs-distribution-team.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports